import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
const _excluded = ["roommates", "utilities", "mailingAddress", "leaseAddendumFileName", "statementCap"],
  _excluded2 = ["firstName", "lastName", "phone", "primaryEmail", "residentialPortalAccessDate", "automaticallySendPaperInvitations", "automaticallySendPaperStatements"],
  _excluded3 = ["address", "propertyAddress"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, OccupancySelector, toast } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { eachDayOfInterval } from 'date-fns';
import { useFormik } from 'formik';
import { formatISO } from 'date-fns';
import moment from 'moment';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { enrollResidentPersonalInitialValues, enrollResidentPersonalScema } from 'src/utils/formValidation/EnrollResident';
import { events, track } from 'src/configs/amplitude';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import { useStore } from 'src/stores';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { generateAddressString } from 'src/utils/address';
import { BillingDetails } from './BillingDetails';
import { CustomAddress } from './CustomAddress';
import { EnrollIn } from './EnrollIn';
import EnrollResidentStepper from './EnrollResidentStepper';
import { LeaseDetails } from './LeaseDetails';
import { ResidentForm } from './ResidentForm';
import useEnrollResidentStyles from './styles';
export const EnrollResident = observer(props => {
  const classes = useEnrollResidentStyles();
  const modalFooterClasses = useModalFooterStyles();
  const store = useStore();
  // const { t } = useTranslation();

  const handleClose = props.handleClose,
    propertyId = props.propertyId,
    setActiveUnitName = props.setActiveUnitName,
    unitAvailableFromDateOnly = props.unitAvailableFromDateOnly,
    enablePortfolioSelect = props.enablePortfolioSelect,
    portfolioId = props.portfolioId,
    newBillingActivated = props.newBillingActivated,
    parentToggleRefreshCallback = props.parentToggleRefreshCallback;
  const customAdminFee = store.enrollResident.enrollResidentInUnit.customAdminFee;
  const customLateFee = store.enrollResident.enrollResidentInUnit.customLateFee;
  const enrollResidentInUnitData = {
    firstName: store.enrollResident.enrollResidentInUnit.firstName,
    lastName: store.enrollResident.enrollResidentInUnit.lastName,
    phone: store.enrollResident.enrollResidentInUnit.phone,
    primaryEmail: store.enrollResident.enrollResidentInUnit.primaryEmail
  };
  const selectedProperty = store.enrollResident.selectedProperty || propertyId;
  const unitId = store.enrollResident.enrollResidentInUnit.unitId;
  const myRef = useRef(null);
  const _useState = useState('rent_details'),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    completedSteps = _useState4[0],
    setCompletedSteps = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    excludedUtilityNames = _useState6[0],
    setExcludedUtilityNames = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loadData = _useState8[0],
    setLoadData = _useState8[1];
  const _useState9 = useState({}),
    _useState0 = _slicedToArray(_useState9, 2),
    previouslyEnrolledToUnit = _useState0[0],
    setPreviouslyEnrolledToUnit = _useState0[1];
  const _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    propertyData = _useState10[0],
    setPropertyData = _useState10[1];
  const _useState11 = useState(unitId || ''),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedUnit = _useState12[0],
    setSelectedUnit = _useState12[1];
  const _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isSubmited = _useState14[0],
    setIsSubmited = _useState14[1];
  const _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isLoadingState = _useState16[0],
    setIsLoadingState = _useState16[1];
  const _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isEmailInvalid = _useState18[0],
    setIsEmailInvalid = _useState18[1];
  /** Holds the in-flight email validation, so Next can wait for a check started by the blur it caused. */
  const emailValidationRef = useRef(null);
  const steps = [{
    label: 'Rent details',
    name: 'rent_details'
  }, {
    label: 'Billing details',
    name: 'billing_details'
  }];
  const activeStep = steps.findIndex(step => step.name === activeTab);
  const stepNames = steps.map(step => step.name);
  const residentFormFormik = useFormik({
    enableReinitialize: false,
    initialValues: enrollResidentInUnitData.firstName ? enrollResidentInUnitData : enrollResidentPersonalInitialValues,
    validationSchema: enrollResidentPersonalScema
  });
  const isNextDisabled = () => {
    if (!selectedUnit || !residentFormFormik.isValid || !store.enrollResident.enrollResidentUnitValidation.mailingAddress || isEmailInvalid) return true;
    let result = false;
    for (var i = 0; i < ((_store$enrollResident = store.enrollResident.enrollResidentInUnitRoommatesValidation) === null || _store$enrollResident === void 0 ? void 0 : _store$enrollResident.length); i++) {
      var _store$enrollResident;
      for (const _ref of Object.entries(store.enrollResident.enrollResidentInUnitRoommatesValidation[i])) {
        var _ref2 = _slicedToArray(_ref, 2);
        const value = _ref2[1];
        if (value !== null) {
          result = true;
          break;
        }
      }
    }
    return result;
  };
  const handleSubmit = async () => {
    setIsSubmited(true);
    track(events.clicked('Confirm Enrollment'));
    residentFormFormik.handleSubmit();
    if (isNextDisabled()) return;
    setIsLoadingState(true);
    const _store$enrollResident2 = store.enrollResident.enrollResidentInUnit,
      roommates = _store$enrollResident2.roommates,
      utilities = _store$enrollResident2.utilities,
      mailingAddress = _store$enrollResident2.mailingAddress,
      leaseAddendumFileName = _store$enrollResident2.leaseAddendumFileName,
      statementCap = _store$enrollResident2.statementCap,
      rest = _objectWithoutProperties(_store$enrollResident2, _excluded);
    const currentRoommates = roommates.map(item => {
      return {
        email: item.email,
        firstName: item.firstName,
        lastName: item.lastName
      };
    });
    const currentUtilities = utilities.map(item => {
      return _objectSpread({
        utilityId: item.utilityId,
        utilityType: item.utilityType,
        utilityCap: item.utilityCap
      }, item);
    });
    const resultData = _objectSpread(_objectSpread({}, rest), {}, {
      mailingAddress: mailingAddress.length > 0 ? mailingAddress : propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyAddress,
      roommates: currentRoommates,
      utilities: currentUtilities
    });
    for (var key in resultData) {
      if (resultData.hasOwnProperty(key)) {
        if (resultData[key] === null || resultData[key] === '') delete resultData[key];
      }
    }
    const firstName = resultData.firstName,
      lastName = resultData.lastName,
      phone = resultData.phone,
      primaryEmail = resultData.primaryEmail,
      residentialPortalAccessDate = resultData.residentialPortalAccessDate,
      automaticallySendPaperInvitations = resultData.automaticallySendPaperInvitations,
      automaticallySendPaperStatements = resultData.automaticallySendPaperStatements,
      restResultData = _objectWithoutProperties(resultData, _excluded2);
    const currentResidentialPortalAccessDate = residentialPortalAccessDate ? residentialPortalAccessDate : formatISO(moment().toDate()).split('T')[0];
    const phoneCode = store.account.featureFlagsStore.isUkrainianMobileCode ? '+38' : '+1';
    const enrollUserData = {
      firstName: firstName,
      lastName: lastName,
      primaryEmail: primaryEmail ? primaryEmail : '',
      phone: /\d/.test(phone) ? "".concat(phoneCode).concat(phone) : '',
      residentialPortalAccessDate: currentResidentialPortalAccessDate
    };
    if (!enrollUserData.residentialPortalAccessDate) {
      delete enrollUserData.residentialPortalAccessDate;
    }
    const enrollUserResp = await store.account.enrollUserAsync.run(beforeSubmitDataValidation(enrollUserData));
    const createNewResidencyData = _objectSpread(_objectSpread({}, restResultData), {}, {
      accountId: enrollUserResp.response,
      primaryEmail: primaryEmail,
      phone: phone,
      residentialPortalAccessDate: currentResidentialPortalAccessDate
    });
    for (const createNewResidencyDataKey in createNewResidencyData) {
      if (createNewResidencyData.hasOwnProperty(createNewResidencyDataKey)) {
        if (!createNewResidencyData[createNewResidencyDataKey]) delete createNewResidencyData[createNewResidencyDataKey];
      }
    }
    if (!createNewResidencyData.notes) {
      createNewResidencyData.notes = '';
    }
    if (!createNewResidencyData.phone) {
      createNewResidencyData.phone = '';
    }
    if (!createNewResidencyData.primaryEmail) {
      createNewResidencyData.primaryEmail = '';
    }
    if (store.residencies.customAddresses.length > 0) {
      const currentAdresses = [];
      store.residencies.customAddresses.map(i => {
        currentAdresses.push({
          addressId: i.addressId,
          isPrimary: i.isPrimary
        });
      });
      createNewResidencyData.addresses = currentAdresses;
    }
    const createNewResidencyResp = await store.residencies.createNewResidencyAsync.run(beforeSubmitDataValidation(_objectSpread(_objectSpread({}, createNewResidencyData), {}, {
      automaticallySendPaperInvitations: localStorage.getItem('livable_demo_mode') !== 'Demo' && !store.company.companyFeatureStore.disableSendPaperInvite ? automaticallySendPaperInvitations : false,
      automaticallySendPaperStatements: localStorage.getItem('livable_demo_mode') !== 'Demo' ? automaticallySendPaperStatements : false
    })));
    if (!createNewResidencyResp || !createNewResidencyResp.response) {
      setIsLoadingState(false);
      return;
    }
    await store.payment.updateResidencyFeeAsync.run({
      adminFee: customAdminFee === null ? null : {
        feeUnitType: FEE_UNIT_TYPES.fixedAmount,
        value: customAdminFee
      },
      lateFee: customLateFee === null ? null : {
        feeUnitType: store.enrollResident.customLateFeeSign,
        value: customLateFee
      },
      residencyId: createNewResidencyResp.response
    });
    await store.payment.putResidentPaymentSettingsAsync.run({
      residencyId: createNewResidencyResp.response,
      statementCap
    });
    await store.residencies.getResidencyOverviewByResidencyIdAsync.run({
      residencyId: createNewResidencyResp.response
    });
    if (createNewResidencyResp !== null && createNewResidencyResp !== void 0 && createNewResidencyResp.isSuccessful) {
      setIsLoadingState(false);
      setActiveTab('billing_details');
      toast('success', {
        body: ['Resident has been successfully enrolled.']
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      parentToggleRefreshCallback && parentToggleRefreshCallback();
      handleClose();
    } else {
      if (store.enrollResident.enrollResidentInUnit.leaseStartDateOnly.length > 0) {
        const billingStartDate = new Date(store.enrollResident.enrollResidentInUnit.billingStartDateOnly);
        const leaseStartDate = new Date(store.enrollResident.enrollResidentInUnit.leaseStartDateOnly);
        if (leaseStartDate.valueOf() > billingStartDate.valueOf()) {
          const intervalBetweenDates = eachDayOfInterval({
            start: billingStartDate,
            end: leaseStartDate
          });
          if (intervalBetweenDates.length > 1) {
            toast('error', {
              body: ['Billing start date can not be greater than Lease start date.']
            });
            return;
          }
        }
      }
    }
  };
  const getProperty = async data => {
    const resp = await store.properties.getPropertyAsync.run(data);
    return resp;
  };
  const getResidenciesAccountData = async accountIds => {
    const resp = await store.account.getUsersProfilesAsync.run({
      accountIds
    });
    return resp;
  };
  useEffect(() => {
    if (!selectedUnit) return;

    // store.enrollResident.initAfterLoadState();

    getProperty({
      propertyId: selectedProperty
    }).then(async resp => {
      var _excludedUtilityInfo;
      if (!resp) return;
      const _resp$response = resp.response,
        address = _resp$response.address,
        propertyAddress = _resp$response.propertyAddress,
        rest = _objectWithoutProperties(_resp$response, _excluded3);
      setPropertyData(_objectSpread({
        propertyAddress: generateAddressString(address)
      }, rest));
      await store.properties.getUnitUtilityProvidersAsync.run({
        propertyId: selectedProperty,
        unitId
      });
      await store.units.getUnitByIdAsync.run({
        unitId
      });
      const getPropertyFees = await store.properties.getPropertyFeesV2Async.run({
        applyToStore: true,
        applyToHomeDashboard: false,
        propertyId: selectedProperty
      });
      if (getPropertyFees.response.adminFee) store.enrollResident.setCustomAdminFee(getPropertyFees.response.adminFee.value);
      if (getPropertyFees.response.lateFee) store.enrollResident.setCustomLateFeeSign(getPropertyFees.response.lateFee.feeUnitType === FEE_UNIT_TYPES.fixedAmount ? FEE_UNIT_TYPES.fixedAmount : FEE_UNIT_TYPES.percentage);
      const selectedUnitData = store.enrollResident.customUnits.find(unit => unit.id === unitId);
      setActiveUnitName(selectedUnitData === null || selectedUnitData === void 0 ? void 0 : selectedUnitData.name);
      const excludedUtilityIds = selectedUnitData === null || selectedUnitData === void 0 ? void 0 : selectedUnitData.utilityOptOutIds;
      let excludedUtilityInfo;
      if (excludedUtilityIds && (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled)) excludedUtilityInfo = await store.utilityProviders.getUtilityInfoAsync.run({
        utilityIds: excludedUtilityIds
      });else excludedUtilityInfo = !!(excludedUtilityIds !== null && excludedUtilityIds !== void 0 && excludedUtilityIds.length) ? await store.utilityProviders.getPropertyUtilityInfoAsync.run({
        utilityIds: excludedUtilityIds,
        propertyId: propertyId
      }) : [];
      const excludedNames = (((_excludedUtilityInfo = excludedUtilityInfo) === null || _excludedUtilityInfo === void 0 || (_excludedUtilityInfo = _excludedUtilityInfo.response) === null || _excludedUtilityInfo === void 0 ? void 0 : _excludedUtilityInfo.utilities) || []).map(utility => utility.utilityTypeName);
      setExcludedUtilityNames(excludedNames);
      const unitAvailabilityResp = await store.units.getUnitAvailabilityByIdAsync.run({
        unitId
      });
      if (unitAvailabilityResp && unitAvailabilityResp !== null && unitAvailabilityResp !== void 0 && unitAvailabilityResp.isSuccessful) {
        const getUsersProfilesResp = await getResidenciesAccountData(unitAvailabilityResp.response.residencyTimePeriods.map(i => i.accountId));
        const unitEnrolments = unitAvailabilityResp.response.residencyTimePeriods;
        if (getUsersProfilesResp !== null && getUsersProfilesResp !== void 0 && getUsersProfilesResp.isSuccessful) getUsersProfilesResp.response.forEach(i => {
          const ind = unitEnrolments.findIndex(uEi => uEi.accountId === i.id);
          if (ind !== -1) {
            unitEnrolments[ind].accountData = i;
          }
        });
        setPreviouslyEnrolledToUnit(unitEnrolments.sort((a, b) => moment(a) - moment(b))[0]);
      }
      setLoadData(true);
      store.enrollResident.setUtilities(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUnit]);
  const handleStep = step => () => {
    setCompletedSteps(step);
    setActiveTab(stepNames[step]);
    myRef.current.scrollIntoView();
  };
  const handleNextStep = async () => {
    const pendingEmailValidation = emailValidationRef.current;
    if (pendingEmailValidation) {
      const isInvalid = await pendingEmailValidation;
      if (isInvalid) return;
    }
    handleStep(1)();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoadingState
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.contentWrapper
  }, /*#__PURE__*/React.createElement("div", {
    ref: myRef
  }), /*#__PURE__*/React.createElement(EnrollResidentStepper, {
    activeStep: activeStep,
    completedSteps: completedSteps,
    handleStep: handleStep,
    steps: steps
  }), activeStep === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.contentBlock2
  }, /*#__PURE__*/React.createElement(EnrollIn, {
    propertyId: selectedProperty,
    selectedUnit: selectedUnit,
    setActiveUnitName: setActiveUnitName,
    setSelectedUnit: setSelectedUnit,
    enablePortfolioSelect: store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && enablePortfolioSelect,
    portfolioId: portfolioId,
    newBillingActivated: newBillingActivated
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.contentBlock
  }, /*#__PURE__*/React.createElement(ResidentForm, {
    validator: residentFormFormik,
    onEmailValidationChange: setIsEmailInvalid,
    emailValidationRef: emailValidationRef
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.contentBlock
  }, /*#__PURE__*/React.createElement(CustomAddress, {
    defaultAddress: propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyAddress
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.contentBlock, " ").concat(classes.contentOccupancyBlock)
  }, /*#__PURE__*/React.createElement(OccupancySelector, {
    currentValue: store.enrollResident.enrollResidentInUnit.occupancy,
    fieldName: "occupancy",
    handleChange: store.enrollResident.changeInUnitValue,
    noMargin: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.contentBlock
  }, /*#__PURE__*/React.createElement(LeaseDetails, {
    isSubmited: isSubmited,
    previouslyEnrolledToUnit: previouslyEnrolledToUnit
  }))) : /*#__PURE__*/React.createElement(BillingDetails, {
    excludedUtilityNames: excludedUtilityNames,
    isDataLoad: loadData,
    propertyData: propertyData,
    modal: "enroll-resident",
    isSubmited: isSubmited,
    unitAvailableFromDateOnly: unitAvailableFromDateOnly,
    showResidentPortalAccess: residentFormFormik.values.primaryEmail.length > 0 && !(residentFormFormik.touched.primaryEmail && !!residentFormFormik.errors.primaryEmail),
    residentEmail: residentFormFormik.values.primaryEmail,
    previouslyEnrolledToUnit: previouslyEnrolledToUnit
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.controllers, " ").concat(modalFooterClasses.modalFooter)
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleClose(),
    variant: "text",
    'custom-attribute': '238-EnrollResident'
  }, "Cancel"), /*#__PURE__*/React.createElement("div", null, activeStep === 1 ? /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleStep(0)(),
    variant: "contained",
    'custom-attribute': '239-EnrollResident'
  }, "Back to rent details") : null, activeStep === 1 ? /*#__PURE__*/React.createElement(Button, {
    disabled: isNextDisabled() || !store.enrollResident.enrollResidentInUnit.billingStartDateOnly,
    onClick: handleSubmit,
    variant: "contained",
    'custom-attribute': '240-EnrollResident'
  }, "Save") : /*#__PURE__*/React.createElement(Button, {
    disabled: isNextDisabled() || !Object.keys(residentFormFormik.touched).length,
    onClick: handleNextStep,
    variant: "contained",
    'custom-attribute': '241-EnrollResident'
  }, "Next"))));
});